export const handleClickOutside = (excludedElements, callback) => {
  document.addEventListener('click', (event) => {
    const clickedInside = excludedElements.some(el => el && el.contains(event.target));
    if (!clickedInside) {
      callback();
    }
  });
};